import { ReactNode } from "react";
import styles from "./EmptyState.module.css";

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  /**
   * A line UNDER the buttons, across the whole card.
   *
   * `action` is an inline-flex row, so a second child handed to it stands
   * BESIDE the buttons rather than below them — and a `border-top` of its own
   * is then drawn as a stub the width of that child. That is what the guild
   * templates' «Source: …» line did. Making `.action` a column instead was not
   * an option: every other screen puts a ROW of buttons there.
   */
  footer?: ReactNode;
}

export function EmptyState({ icon, title, description, action, footer }: Props) {
  return (
    <div className={styles.root}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
      {action && <div className={styles.action}>{action}</div>}
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
}
